import React, { useEffect } from 'react'
import {
    Route,
    Routes, Outlet,
    useSearchParams, Navigate,
} from 'react-router-dom-v5-compat'
import { EmbeddedHelp } from './Embed'
import SSOZendesk from './SSOZendesk'


const HelpIndex = ({history,location}) => {
    return (
        <Routes >
            <Route path="help" element={<SSOZendesk/>}>
                <Route path="*" element={<Navigate to="" />} />
            </Route>
        </Routes>
    )
}

export default HelpIndex